import { useEffect, useState } from 'react';
import { apiFetch } from '../network';

export function useCavallunaShows() {
  const [shows, setShows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refreshShows = async () => {
    setLoading(true);
    setError(false);

    try {
      const response = await apiFetch('/cavalluna/shows');

      if (!response.ok) {
        throw new Error('request_failed');
      }

      const data = await response.json();
      setShows(Array.isArray(data.shows) ? data.shows : []);
    } catch (requestError) {
      setShows([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshShows();
  }, []);

  return {
    shows,
    loading,
    error,
    refreshShows
  };
}
